import React from 'react'
import { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { PiTable } from "react-icons/pi";
import { HiOutlineMegaphone } from "react-icons/hi2";
import { LuFolderCog } from "react-icons/lu";
import "../Notifications/ShowNotifications.scss"
import { PiCourtBasketball } from "react-icons/pi";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { viewNotificationURL } from '../../../Services/BackendUrl';
import axios from "axios";
import { encryptedAuth } from '../../../Services/EncryptData';
dayjs.extend(utc);
dayjs.extend(timezone);




export const ShowNotifications = ({
    visibleNotificatios,
    todayNotifications,
    yesterdayNotifications,
    olderNotifications,
    setVisibleNotifications,
    setMessages,
    groupNotificationsByDate,
    onNotificationNavigate,
}) => {


    const [hovered, setHovered] = useState({ section: null, index: null });
    const [showOlder, setShowOlder] = useState(false)



    const getNotificationIcon = (type) => {
        switch (type) {
            case "USER_REGISTRATION":
                return (<div className='notifi-icon-container'><PiTable className='notifi-icon' /></div>);
            case "CONTACT_US":
                return (
                    <div className='notifi-icon-container'><HiOutlineMegaphone className='notifi-icon' /></div>
                );
            case "FEEDBACK":
                return (<div className='notifi-icon-container'><LuFolderCog className='notifi-icon' /></div>);
            case "BOOKING":
                return (<div className='notifi-icon-container'><PiCourtBasketball className='notifi-icon' /></div>);
            default:
                return "";
        }
    };

    const markAsViewed = async (id) => {
        try {


            const res = await axios.post(
                viewNotificationURL,
                { notificationId: id },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Encrypted ${encryptedAuth}`,
                    },
                }
            );
            if (res.status === 200) {
                groupNotificationsByDate(res.data)
            }

        }
        catch (err) {
            console.error(err);

        }
    };

    const onHide = () => {
        setVisibleNotifications(false)
        setMessages([])
    }

    const getPageByNotificationType = (type) => {
        switch (type) {
            case "USER_REGISTRATION":
                return "registration";
            case "CONTACT_US":
                return "contactrequest";
            case "FEEDBACK":
                return "feedback";
            case "BOOKING":
                return "slotbooking";
            case "ANNOUNCEMENT":
                return "announcement";
            default:
                return "dashboard";
        }
    };

    const handleNotificationClick = async (notification) => {
        if (!notification?.is_viewed) {
            await markAsViewed(notification.id);
        }
        const page = getPageByNotificationType(notification?.type);
        onHide();
        if (onNotificationNavigate) {
            onNotificationNavigate(page);
        }
    };




    const headerContent = (
        <div>
            <h3 style={{ color: "black", paddingTop: "10px", paddingBottom: "5px", fontFamily: "Lufga", paddingLeft: "25px", paddingRight: "25px" }}>Notifications</h3>
            <p style={{ color: "#838383", fontSize: "14px", paddingTop: "5px", paddingBottom: "10px", fontFamily: "Lufga", paddingLeft: "25px", paddingRight: "25px" }}> Stay Updated with your latest notifications</p>

        </div>
    )

    return (
        <div className="card flex justify-content-center dialog-container" >

            <Dialog header={headerContent} draggable={false} visible={visibleNotificatios} style={{ width: "500px", height: "400px" }} onHide={onHide} appendTo="self">
                <div style={{ borderTop: "1px solid #838383", paddingLeft: "25px", paddingRight: "25px" }}>
                    <h4 className='notify-title'>Today</h4>
                    {todayNotifications.length > 0 ? (
                        <>

                            {todayNotifications.map((n, i) => <div key={n.id} className={`notification-wrapper ${hovered.section === "today" && hovered.index !== null && hovered.index !== i ? "blurred" : ""}`}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className={`notify-content ${hovered.section === "today" && hovered.index === i ? "zoomed" : ""}`}
                                        onMouseEnter={() => {
                                            setHovered({ section: "today", index: i });
                                            if (!n.is_viewed) {
                                                markAsViewed(n.id);
                                            }
                                        }}
                                        onMouseLeave={() => setHovered({ section: null, index: null })}
                                        onClick={() => handleNotificationClick(n)}
                                        style={{ cursor: "pointer" }}>
                                        {getNotificationIcon(n.type)}
                                        <div style={{ paddingLeft: "10px" }}>
                                            <Button label={hovered.section === "today" && hovered.index === i ? n.message : n.title}
                                            />

                                            <div style={{ color: "#989898", fontSize: "12px", fontFamily: "Lufga", paddingTop: "5px" }}>{dayjs.utc(n.createdAt)
                                                .format("MMMMDD,YYYY")}{" "}{" "}{" "}{" "}{dayjs.utc(n.createdAt)
                                                    .format("h:mmA")}
                                            </div>

                                        </div>
                                    </div>
                                    {!n.is_viewed && !(hovered.section === "today" && hovered.index === i) && (
                                        <div className="viewed-notifi">
                                            <i className="pi pi-circle-fill"></i>
                                        </div>
                                    )}

                                </div>
                            </div>)
                            }

                        </>
                    ) : <div className='no-notify'>No Notifications Available..</div>}
                </div>
                <div style={{ paddingLeft: "25px", paddingRight: "25px" }}>
                    <h4 className='notify-title'>Yesterday</h4>
                    {yesterdayNotifications.length > 0 ? (
                        <>


                            {yesterdayNotifications.map((n, i) => <div key={n.id} className={`notification-wrapper ${hovered.index !== null && hovered.section === "yesterday" && hovered.index !== i ? "blurred" : ""}`}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className={`notify-content ${hovered.section === "yesterday" && hovered.index === i ? "zoomed" : ""}`}
                                        onMouseEnter={() => {
                                            setHovered({ section: "yesterday", index: i });
                                            if (!n.is_viewed) {
                                                markAsViewed(n.id);
                                            }
                                        }}
                                        onMouseLeave={() => setHovered({ section: null, index: null })}
                                        onClick={() => handleNotificationClick(n)}
                                        style={{ cursor: "pointer" }}>
                                        {getNotificationIcon(n.type)}

                                        <div>
                                            <Button label={hovered.section === "yesterday" && hovered.index === i ? n.message : n.title} />

                                            <div style={{ color: "#989898", fontSize: "12px", fontFamily: "Lufga" }}>{dayjs.utc(n.createdAt)
                                                .format("MMMMDD,YYYY")}{" "}{" "}{" "}{" "}{dayjs.utc(n.createdAt)
                                                    .format("h:mmA")}
                                            </div>

                                        </div>
                                    </div>
                                    {!n.is_viewed && !(hovered.section === "yesterday" && hovered.index === i) && (
                                        <div className="viewed-notifi">
                                            <i className="pi pi-circle-fill"></i>
                                        </div>
                                    )}
                                </div>
                            </div>)}
                        </>
                    ) : <div className='no-notify'>No Notifications Available..</div>}
                </div>
                <div style={{ paddingLeft: "25px", paddingRight: "25px", paddingTop: "10px", paddingBottom: "10px" }}>

                    {olderNotifications.length > 0 && (
                        <h4 className='notify-title' onClick={() => setShowOlder(!showOlder)} style={{ color: "#2095f5 ", cursor: "pointer" }}>
                            {showOlder ? "Hide Older" : "Show Older"}
                        </h4>
                    )}


                    {
                        showOlder ? (
                            <>
                                {
                                    olderNotifications.length > 0 ? (
                                        <>
                                            {olderNotifications.map((n, i) => <div key={n.id} className={`notification-wrapper ${hovered.index !== null && hovered.section === "tomorrow" && hovered.index !== i ? "blurred" : ""}`}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div className={`notify-content ${hovered.section === "tomorrow" && hovered.index === i ? "zoomed" : ""}`}
                                                        onMouseEnter={() => {
                                                            setHovered({ section: "tomorrow", index: i });
                                                            if (!n.is_viewed) {
                                                                markAsViewed(n.id);
                                                            }
                                                        }}
                                                        onMouseLeave={() => setHovered({ section: null, index: null })}
                                                        onClick={() => handleNotificationClick(n)}
                                                        style={{ cursor: "pointer" }}>
                                                        {getNotificationIcon(n.type)}
                                                        <div>
                                                            <Button label={hovered.section === "tomorrow" && hovered.index === i ? n.message : n.title} />

                                                            <div style={{ color: "#989898", fontSize: "12px", fontFamily: "Lufga" }}>{dayjs.utc(n.createdAt)
                                                                .format("MMMMDD,YYYY")}{" "}{" "}{" "}{" "}{dayjs.utc(n.createdAt)
                                                                    .format("h:mmA")}

                                                            </div>

                                                        </div>
                                                    </div>
                                                    {!n.is_viewed && !(hovered.section === "tomorrow" && hovered.index === i) && (
                                                        <div className="viewed-notifi">
                                                            <i className="pi pi-circle-fill"></i>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>)}
                                        </>
                                    ) : <div className='no-notify'>No Notifications Available..</div>
                                }
                            </>
                        ) : null
                    }
                </div>

            </Dialog>

        </div>
    )
}
